export default __webpack_public_path__ + "static/media/footer-shape-1.88427bf5.png";